(() => {
  const root = () => document.querySelector('[data-wbq-root]');

  const fmt = (cents, currency) => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'AUD' })
        .format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const rows = (r) => Array.prototype.slice.call(r.querySelectorAll('[data-wbq-row]'));

  const recalc = (r) => {
    const currency = r.getAttribute('data-currency');
    let total = 0;
    rows(r).forEach((row) => {
      const unit = parseInt(row.getAttribute('data-unit'), 10) || 0;
      const input = row.querySelector('[data-wbq-qty]');
      let q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      const line = unit * q;
      total += line;
      const cell = row.querySelector('[data-wbq-linetotal]');
      if (cell) cell.textContent = fmt(line, currency);
    });
    const out = r.querySelector('[data-wbq-total]');
    if (out) out.textContent = fmt(total, currency);
  };

  const say = (r, msg, isError) => {
    const el = r.querySelector('[data-wbq-status]');
    if (!el) return;
    el.textContent = msg || '';
    el.classList.toggle('is-error', !!isError);
  };

  const cartUrl = () =>
    (window.routes && window.routes.cart_url) ||
    (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_url) ||
    '/cart';

  const addUrl = () =>
    (window.routes && window.routes.cart_add_url) ||
    (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_add_url) ||
    '/cart/add';

  const addAll = (r, btn) => {
    btn.disabled = true;
    say(r, r.getAttribute('data-msg-adding') || 'Adding…', false);

    /* ⚠ Read the cart FIRST. /cart/add with items[] is atomic: if any single
       line exceeds what Shopify will allow, the whole request 422s and none of
       the lines land. A quantity that is fine on its own can still fail because
       the same variant is already sitting in the cart, so the ceiling has to be
       reduced by what is already there — the same reasoning as
       assets/wb-kit-builder.js:373. */
    fetch(cartUrl() + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : { items: [] }))
      .catch(() => ({ items: [] }))
      .then((cart) => {
        const inCart = {};
        (cart.items || []).forEach((it) => {
          inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity;
        });

        const items = [];
        let clamped = 0;
        rows(r).forEach((row) => {
          const id = parseInt(row.getAttribute('data-variant-id'), 10);
          const ceiling = parseInt(row.getAttribute('data-ceiling'), 10);
          const input = row.querySelector('[data-wbq-qty]');
          let q = parseInt(input.value, 10);
          if (isNaN(q) || q <= 0) return;

          if (ceiling >= 0) {
            const room = Math.max(0, ceiling - (inCart[id] || 0));
            if (q > room) {
              q = room;
              clamped += 1;
              input.value = q;
            }
          }
          if (q > 0) items.push({ id: id, quantity: q });
        });

        if (!items.length) {
          say(r, r.getAttribute('data-msg-none') || 'Nothing to add — every line is zero or out of stock.', true);
          btn.disabled = false;
          recalc(r);
          return;
        }

        return fetch(addUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then((res) => res.json().then((body) => ({ ok: res.ok, body: body })))
          .then((out) => {
            if (!out.ok) {
              /* ⚠ A failed add is not proof that nothing was added — the request
                 can fail after Shopify has committed part of it. Send the buyer
                 to the cart to see the truth rather than asserting a state. */
              say(r, (out.body && out.body.description) || 'Could not add everything. Check your cart.', true);
              btn.disabled = false;
              return;
            }
            if (clamped) {
              say(r, r.getAttribute('data-msg-clamped') || 'Added. Some quantities were reduced to available stock.', false);
            }
            window.location.href = cartUrl();
          });
      })
      .catch(() => {
        say(r, 'Something went wrong. Please try again.', true);
        btn.disabled = false;
      });
  };

  const bind = () => {
    const r = root();
    if (!r || r.dataset.wbqBound) return;
    r.dataset.wbqBound = 'true';

    r.addEventListener('input', (e) => {
      if (e.target && e.target.hasAttribute('data-wbq-qty')) recalc(r);
    });

    const btn = r.querySelector('[data-wbq-add]');
    if (btn) btn.addEventListener('click', () => addAll(r, btn));

    recalc(r);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
